import { IExportColumnModel } from '../../../../../src/shared/models'


export const UserChangeHistoryColumnList: IExportColumnModel[] = [
{
        isAllChecked: true,
        name: "Fields from User change histories",
        value: "user_change_histories",
        columns: [
            {
                name: "Id",
                value: "id",
                checked: true,
            },
            {
                name: "Item ID",
                value: "item_id",
                checked: true,
            },
            {
                name: "Item Type",
                value: "item_type",
                checked: true,
            },
            {
                name: "Event",
                value: "event",
                checked: true,
            },
            {
                name: "Edited By",
                value: "whodunnit",
                checked: true,
            },
            {
                name: "Old Value",
                value: "object",
                checked: true,
            },
            {
                name: "New Value",
                value: "object_changes",
                checked: true,
            },
            {
                name: "Created At",
                value: "created_at",
                checked: true,
            },
            {
                name: "Updated At",
                value: "updated_at",
                checked: true,
            },
            {
                name: "IP",
                value: "ip",
                checked: true,
            }
        ]

    },
    {
        isAllChecked: true,
        name: "Fields from associated User",
        value: "users",
        columns: [
            {
                name: "Id",
                value: "Id",
                checked: true,
            },
             {
                name: "Email",
                value: "email",
                checked: true,
            },
            {
                name: "Reset Password Sent At",
                value: "reset_password_sent_at",
                checked: true,
            },
            {
                name: "Sign In Count",
                value: "sign_in_count",
                checked: true,
            },
            {
                name: "Created At",
                value: "created_at",
                checked: true,
            },
            {
                name: "Updated At",
                value: "updated_at",
                checked: true,
            },
            {
                name: "Name",
                value: "name",
                checked: true,
            },
            {
                name: "Title",
                value: "title",
                checked: true,
            },
            {
                name: "Phone",
                value: "phone",
                checked: true,
            },
            {
                name: "Account Id",
                value: "account_id",
                checked: true,
            },
            {
                name: "Demo",
                value: "demo",
                checked: true,
            },
            {
                name: "Needs Setup",
                value: "needs_setup",
                checked: true,
            },
            {
                name: "Role ID",
                value: "role_id",
                checked: true,
            },
            {
                name: "Favorite Dashboard ID",
                value: "favorite_dashboard_id",
                checked: true,
            },
            {
                name: "Billable",
                value: "billable",
                checked: true,
            },
            {
                name: "Staq Admin",
                value: "staq_admin",
                checked: true,
            },
            {
                name: "Deactivated",
                value: "deactivated",
                checked: true,
            },
            {
                name: "Invited By ID",
                value: "invited_by_id",
                checked: true,
            }
        ]

    },
];
